import { NEW_FORGOT_PASSWORD_CLEAR_STATE } from '../../constants';
import { withType } from '../../../utils/actionOperations';

export const newForgotPasswordClearState = () => {
    return dispatch => {
        dispatch(withType(NEW_FORGOT_PASSWORD_CLEAR_STATE));
    };
};